var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"state"},[(_vm.type==='loading')?_c('div',{staticClass:"skeleton",attrs:{"aria-hidden":"true"}},[_c('i'),_c('i'),_c('i'),_c('i')]):_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.title))]),(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }